import React, { lazy, Suspense } from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import Icon from "components/AppIcon";

// Lazy load pages for better performance and code splitting
const NotFound = lazy(() => import("pages/NotFound"));
const PortfolioAnalytics = lazy(() => import('./pages/portfolio-analytics'));
const AccountManagement = lazy(() => import('./pages/account-management'));
const MainTradingDashboard = lazy(() => import('./pages/main-trading-dashboard'));
const MarketAnalysisHub = lazy(() => import('./pages/market-analysis-hub'));
const RiskManagementCenter = lazy(() => import('./pages/risk-management-center'));
const LoginScreen = lazy(() => import('./pages/login-screen'));
const RegisterScreen = lazy(() => import('./pages/register-screen'));

// Loading component for lazy loaded routes
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <div className="text-center">
      <Icon name="Loader2" size={48} className="text-primary mb-4 animate-spin mx-auto" />
      <p className="text-muted-foreground text-lg">Yükleniyor...</p>
    </div>
  </div>
);

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <Suspense fallback={<PageLoader />}>
          <RouterRoutes>
            {/* Authentication Routes */}
            <Route path="/login-screen" element={<LoginScreen />} />
            <Route path="/register-screen" element={<RegisterScreen />} />
            
            {/* Main Application Routes */}
            <Route path="/" element={<MainTradingDashboard />} />
            <Route path="/portfolio-analytics" element={<PortfolioAnalytics />} />
            <Route path="/account-management" element={<AccountManagement />} />
            <Route path="/main-trading-dashboard" element={<MainTradingDashboard />} />
            <Route path="/market-analysis-hub" element={<MarketAnalysisHub />} />
            <Route path="/risk-management-center" element={<RiskManagementCenter />} />
            
            {/* Navigation Routes */}
            <Route path="/transaction" element={<MainTradingDashboard />} />
            <Route path="/prop" element={<MarketAnalysisHub />} />
            <Route path="/explore" element={<PortfolioAnalytics />} />
            
            {/* Fallback Route */}
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </Suspense>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;